// Copyright (c) Ensho Health, 2022 to present

import client from './client-http.js';

export async function sendNotification(notification) {
  try {
    if (!notification.hasOwnProperty('info')) {
      notification.info = {};
    }
    notification.info.url = window.location.href;
    notification.appCode = process.env.REACT_APP_CODE;
    await client.post('/notify', notification);
  } catch (error) {
    console.error(
      'notification.api.sendNotification: ' + error.response.status
    );
    throw new Error('something went wrong while sending a notification');
  }
}
